<template>
  <div class='reg-filter'>
    <div id='activityFilter'>
      <div
        data-toggle="dropdown"
        class="text-right cursor-pointer"
      >
        <span class="dropdown-toggle cursor">
          <span @click="showHideFilter()">
            <img src="/static/images/icons/searchbar_filtermodal_icon.svg"/>
            <span class="filter-header">{{$t('filter')}}</span>
          </span>
        </span>
      </div>
      <div class="dropdown-menu dropdown-menu-left registration-header-filter-ul" :class="{'hide-field': collapsed}">
        <div class="col-xs-12">
          <span class="col-xs-12 filterByText pl-0">{{$t('filterBy')}}:</span>
        </div>
        <div class="col-xs-12 p-0">
          <hr class="divider-line" />
        </div>
        <div class="col-xs-12 filter-wrapper p-0">
          <div class="col-xs-12 account-status-carret-section p-0 filter-options-outline">
            <span>
              <button data-toggle="collapse" data-target="#collapseAccountStatus" data-parent="#accordion">
                <img data-v-32d4f241="" src="/static/images/icons/emergo_chevron_down.svg" class="downCarret">
                <img data-v-32d4f241="" src="/static/images/icons/emergo_chevron_down.svg" class="upCarret">
              </button>
            </span>
            <div class="filter-options">{{ $t('accountStatus') }}</div>
          </div>
          <div class="col-xs-12 collapse p-0" id="collapseAccountStatus">
            <ul role="menu" v-on:click.stop class="mb-0 p-0">
              <li class="col-xs-12 record-type-item p-0 pt-14">
                <div class="col-xs-12 p-0 d-flex">
                  <!-- <div class="col-xs-1 p-0 activityTracker-checkbox">
                    <span class="checkbox">
                      <label>
                        <input type="checkbox" v-model="activate" @change="filterData('active')" />
                        <span class="cr">
                          <img class="select-check" src="/static/images/icons/select_check.svg" alt="">
                        </span>
                      </label>
                    </span>
                  </div> -->
                  <div class="checkbox-wrapper">
                    <label class="custom-checkbox">
                      <!-- <input :value="cellVal" v-model="userSelectableColumns" type="checkbox" /> -->
                      <input type="checkbox" v-model="activate" />
                      <span class="select-check"></span>
                    </label>
                  </div>
                  <div class="col-xs-10 pl-8 pr-0">
                    <span>{{ $t('Active') }}</span>
                  </div>
                </div>
              </li>
              <li class="col-xs-12 record-type-item p-0 pt-14 pb-18">
                <div class="col-xs-12 p-0 d-flex">
                  <!-- <div class="col-xs-1 p-0 activityTracker-checkbox">
                    <span class="checkbox">
                      <label>
                        <input type="checkbox" v-model="deactivate" @change="filterData('deactivate')" />
                        <span class="cr">
                          <img class="select-check" src="/static/images/icons/select_check.svg" alt="">
                        </span>
                      </label>
                    </span>
                  </div> -->
                  <div class="checkbox-wrapper">
                    <label class="custom-checkbox">
                      <!-- <input :value="cellVal" v-model="userSelectableColumns" type="checkbox" /> -->
                      <input type="checkbox" v-model="deactivate" />
                      <span class="select-check"></span>
                    </label>
                  </div>
                  <div class="col-xs-10 pl-8 pr-0">
                    <span>{{ $t('deactivated') }}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-xs-12 p-0">
             <hr class="divider-line" />
          </div>
          <div class="col-xs-12 account-status-carret-section p-0 filter-options-outline">
            <span>
              <button data-toggle="collapse" data-target="#collapseCreatedDate" data-parent="#accordion">
                <img data-v-32d4f241="" src="/static/images/icons/emergo_chevron_down.svg" class="downCarret">
                <img data-v-32d4f241="" src="/static/images/icons/emergo_chevron_down.svg" class="upCarret">
              </button>
            </span>
            <div class="filter-options">{{ $t('dateCreated') }}</div>
          </div>
          <div class="col-xs-12 collapse p-0" id="collapseCreatedDate">
            <ul role="menu" v-on:click.stop class="mb-0 p-0">
              <li class="col-xs-12 record-type-item p-0 pt-14 selected-box">
                <div class="col-xs-12 p-0">
                  <label class="m-0">
                    <input type="radio" value="7 days" v-model="selectedDate" @change="hideDateRange"/>
                    <span class="default-label">{{ $t('last7Days') }}</span>
                  </label>
                </div>
              </li>
              <li class="col-xs-12 record-type-item p-0 pt-14">
                <div class="col-xs-12 p-0">
                  <label class="m-0">
                    <input type="radio" value="30 days" v-model="selectedDate" @change="hideDateRange"/>
                    <span class="default-label">{{ $t('last30Days') }}</span>
                  </label>
                </div>
              </li>
              <li class="col-xs-12 record-type-item p-0 pt-14">
                <div class="col-xs-12 p-0">
                  <label class="m-0">
                    <input type="radio" value="within year" v-model="selectedDate" @change="hideDateRange"/>
                    <span class="default-label">{{ $t('withinLastYear') }}</span>
                  </label>
                </div>
              </li>
              <li class="col-xs-12 record-type-item p-0 pt-14">
                <div class="col-xs-12 p-0 d-flex">
                  <div class="col-xs-12 p-0">
                  <label class="m-0 pb-12">
                    <input type="radio" value="dates" v-model="selectedDate" @change="filterAccounts" />
                    <span class="default-label date-field">{{ $t('dateRange') }}:</span>
                  </label>
                  <filter-date class="pl-32" name="launchpadFilterDate" ref="dateComponent" :showInAccountsFilter="false" :disabledDate="disabledDate" @dateRange="dateRange"></filter-date>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-xs-12 footer">
          <button class="footer-btn footer-clear-btn" @click="resetFilter">{{$t('clearLabel')}}</button>
          <button class="footer-btn footer-apply-btn" @click="applyFilter" :disabled="checkDisabled()">{{$t('apply')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import * as moment from 'moment';
import FilterDate from '../UIComponents/FilterDate.vue';

export default {
  components: {
    FilterDate,
  },
  data() {
    return {
      collapsed: true,
      showInAccountsFilter: false,
      activate: false,
      deactivate: false,
      selectedDate: '',
      disabledDate: true,
      selectedDateRange: {
        from: '',
        to: '',
      },
    };
  },
  methods: {
    checkDisabled() {
      if (this.activate || this.deactivate || this.selectedDate) {
        return false;
      }
      return true;
    },
    applyFilter() {
      this.filterData();
      this.setData();
      this.showHideFilter();
      $(window).scrollTop(0);
    },
    filterData() {
      this.$emit('updateStatus', this.activate, this.deactivate);
      // let
    },
    setData() {
    //   this.disabledDate = true;
      this.disabledDate = false;
      let startDate = '';
      let endDate = '';
      if (this.selectedDate === '7 days') {
        this.disabledDate = true;
        // selects last 7 days

        startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
        endDate = moment().format('YYYY-MM-DD');
      } else if (this.selectedDate === '30 days') {
        this.disabledDate = true;
        startDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
        endDate = moment().format('YYYY-MM-DD');
      } else if (this.selectedDate === 'within year') {
        // user selects year
        this.disabledDate = true;
        const date = moment();
        startDate = moment(date).year() - 1 + moment(date).format('-01-01');
        endDate = moment(date).year() - 1 + moment(date).format('-12-31');
        /* startDate  = moment().subtract(365, "days").format("YYYY-MM-DD")
                    endDate = moment().format('YYYY-MM-DD') */
      } else {
        startDate = this.selectedDateRange.from;
        endDate = this.selectedDateRange.to;
      }
      this.$emit('updateDate', startDate, endDate);
    },
    hideDateRange() {
      this.disabledDate = true;
    },
    filterAccounts() {
      this.disabledDate = false;
    },
    dateRange(date) {
      this.disabledDate = false;
      this.selectedDateRange.from = date.from;
      this.selectedDateRange.to = date.to;
    //   this.$emit('updateDate', date.from, date.to);
    },
    resetFilter() {
      this.activate = false;
      this.deactivate = false;
      this.disabledDate = true;
      this.selectedDate = '';
      this.$emit('updateStatus', this.activate, this.deactivate);
      this.$emit('updateDate', '', '');
      this.$refs.dateComponent.start_approval_date = '';
      this.$refs.dateComponent.end_approval_date = '';
      this.selectedDateRange.from = '';
      this.selectedDateRange.to = '';
      this.showHideFilter();
      $(window).scrollTop(0);
    },
    showHideFilter() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>

<style scoped>
/* .alert-menu {
  padding-left: 32px;
} */
.pl-32{
  padding-left: 32px;
}
.pb-12{
  padding-bottom: 12px;
}
.filterByText{
  color: #000;
  font-size: 14px;
  font-family: Open Sans;
  font-weight: 600;
  line-height: 26px;
}
.divider-line {
  border-top: 1px solid #D3D3D3;
  padding: 0px;
  margin: 10px 0px 8px 0px;
}

.reg-filter {
  position: absolute;
  z-index: 3;
  /* left: 15px !important;
  margin-left: -20px; */
  top: 14px;
  /* top: 2px; */
  right: 0px;
}
#activityFilter {
  height: 52px;
  margin-left: 5px;
}
/* .default-label {
  padding-left: 13px;
} */
.default-label.date-field {
  margin-bottom: 12px;
}
.pl-9 {
  padding-left: 9px;
}
label > input[type="radio"] {
   display: none;
}
label > input[type="radio"] + *::before {
  content: "";
  display: inline-block;
  vertical-align: bottom;
  width: 18px;
  height: 18px;
  margin-right: 12px;
  margin-bottom: 3px;
  border-radius: 50%;
  border-style: solid;
  border-width: 2px;
  border-color: #4D4D4D;
}
label > input[type="radio"]:checked + *::before {
  background: radial-gradient(#01518a 0%, #01518a 46%, transparent 51%, transparent);
  border-color: #01518a;
}
/* label > input[type="radio"]:checked + * {
  color: #01518a;
} */

.pt-25 {
  padding-top: 25px;
}

.pb-18 {
  padding-bottom: 18px;
}
.filter-card-header {
  background: #FFFFFF;
}
.filter-text{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #000000;
  padding-left: 14px;
}
.filter-card-outline {
  padding: 22px 0px 24px 0px;
}

.hide-field {
  display: none !important;
}
.registration-header-filter-ul {
  position: relative;
  padding: 0px;
  width: 247px;
  min-height: 712px;
  display: block;
  background: #ffffff;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
  margin-top: 20px !important;
  border-radius: 0px;
  border: 1px solid #B3B3B3;
  padding-top: 15px !important;
}
.dropdown-menu {
  margin: 0px 0px 0px;
  padding: 0px;
}
.dropdown-menu-left {
  right: auto;
  left: 0px;
  top: -4px;
  margin: 6px 0 0;
}
.filter-wrapper {
  /* padding-bottom: 44px;
  height: 376px; */
  overflow: hidden;

}

/* .account-status-carret-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
} */

.account-status-carret-section button {
  background-color: transparent !important;
  padding: 0px;
  border: none;
}
.account-status-carret-section span button[aria-expanded="true"] img.downCarret {
  display: none;
}

.account-status-carret-section span button[aria-expanded="true"] img.upCarret {
  display: inline-block;
}
.account-status-carret-section span button img.downCarret {
  display: inline-block;
  transform: rotate(180deg);
}
.account-status-carret-section span button img.upCarret {
  display: none;
}
.filter-options-outline {
  padding: 0px 0px 0px 18px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.filter-options {
  color: #4D4D4D;
  font-size: 14px;
  font-family: Open Sans;
  font-weight: 600;
  padding-left: 8px;
}
.record-type-item {
  color: #4D4D4D;
  font-size: 14px;
  font-family: Open Sans;
  font-style: normal;
  line-height: 22px;
  padding: 0px 0px 0px 47px;
  list-style-type: none;
}
.select-check {
  height: 11px;
  width: 11px;
  position: absolute;
  left: 1px;
  top: 1px
}
/* .activityTracker-checkbox>.checkbox .cr {
  border: 1px solid #01518a;
  width: 16px;
  height: 16px;
}
.activityTracker-checkbox>.checkbox label input[type="checkbox"]:checked+.cr {
  background-color: #0B3C61;
} */
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  /* border-radius: 20px; */
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
::-webkit-scrollbar-thumb:hover {
  background: #D9D9D9;
  ;
}
.footer {
  position: absolute;
  bottom: 12px;
  padding: 0px 12px 0px 12px;
  display: flex;
  justify-content: space-between;
}

.filter-header {
  color: #4D4D4D;
  font-size: 14px;
  padding: 3px 16px 0px 9px;
  position: relative;
  top: 2px;
}

.footer-btn {
border-radius: 3px;
font-weight: 600;
font-size: 16px;
line-height: 22px;
border: 1px solid transparent;
padding: 6px 16px;
cursor: pointer;
}

.footer-btn:disabled {
  cursor: not-allowed;
}

.footer-clear-btn, .footer-clear-btn:hover {
background: #E6E6E6;
color: #404040;
}

.footer-apply-btn, .footer-apply-btn:hover {
background: #01518A;
color: #ffffff;
}

/* =================================== */

.plr-16 {
  padding-left: 16px;
  padding-right: 16px;
}

.mb-7 {
  margin-bottom: 7px;
}
.pt-14{
  padding-top: 14px;
}
.registration-header-reg-filter {
  position: absolute;
  z-index: 3;
  left: 15px !important;
  top: -9px;
  margin-left: -30px;
}

.mt-7 {
  margin-top: 7px;
}
.checkbox-wrapper {
  position: relative;
  width: 18px;
  height: 18px;
}
.custom-checkbox {
  display: inline-block;
}

.custom-checkbox input[type='checkbox'] {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
}

.select-check {
  position: absolute;
  left: 0;
  top: 1px;
  height: 18px;
  width: 18px;
  cursor: pointer;
  border: 2px solid #000000;
  border-radius: 3px;
}

.custom-checkbox input[type='checkbox']:checked ~ .select-check {
  background-color: #01518a;
  background-image: url(/static/images/icons/checkbox.svg);
  background-size: 12px 15px;
  background-repeat: no-repeat;
  background-position: center;
  border: none;
}

.select-check:after {
  content: '';
  position: absolute;
  display: none;
}

.custom-checkbox input[type='checkbox']:checked ~ .select-check:after {
  display: block;
}
</style>
